var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 11.9999C21.9998 6.47711 17.5227 2 11.9999 2C6.47711 2 2 6.47711 2 11.9999C2 16.9912 5.65682 21.1282 10.4374 21.8784V14.8905H7.89839V11.9999H10.4374V9.79682C10.4374 7.29058 11.9303 5.90622 14.2145 5.90622C15.3086 5.90622 16.453 6.10153 16.453 6.10153V8.56245H15.192C13.9498 8.56245 13.5624 9.33328 13.5624 10.1241V11.9999H16.3358L15.8925 14.8905H13.5624V21.8784C18.343 21.1282 21.9998 16.9912 21.9998 11.9999Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8923 14.8905L16.3356 11.9999H13.5622V10.1241C13.5622 9.33331 13.9496 8.56247 15.1918 8.56247H16.4528V6.10156C16.4528 6.10156 15.3084 5.90625 14.2143 5.90625C11.9301 5.90625 10.4372 7.2906 10.4372 9.79684V11.9999H7.89819V14.8905H10.4372V21.8784C10.9541 21.9594 11.4765 22 11.9997 21.9999C12.5313 21.9999 13.0531 21.9583 13.5622 21.8784V14.8905H15.8923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2f5535573f885857e81e991f01d784b9.svg";
export { ForwardRef as ReactComponent };